var React = require('react');

function Location (props) {
    return React.createElement("symbol",props,[React.createElement("title",{"key":0},"Lokasjon"),React.createElement("path",{"d":"M7.506 17.82a.795.795 0 0 1-1.012 0C6.228 17.6 0 12.377 0 6.781 0 3.042 3.14 0 7 0s7 3.043 7 6.782C14 12.378 7.772 17.6 7.506 17.82zM7 1.5c-3.001 0-5.444 2.37-5.444 5.282 0 4.052 4.004 8.117 5.443 9.448 1.44-1.332 5.445-5.404 5.445-9.448C12.444 3.87 10.001 1.5 7 1.5zm0 8.306c-1.716 0-3.111-1.346-3.111-3s1.395-3 3.111-3c1.716 0 3.111 1.346 3.111 3s-1.395 3-3.111 3zm0-4.5c-.857 0-1.556.672-1.556 1.5 0 .827.699 1.5 1.556 1.5.858 0 1.556-.673 1.556-1.5 0-.828-.698-1.5-1.556-1.5z","key":1})]);
}

Location.displayName = "Location";

Location.defaultProps = {"viewBox":"0 0 14 18"};

module.exports = Location;

Location.default = Location;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/location.svg
// module id = 1275
// module chunks = 0